import { Stack } from 'expo-router';

import { DEFAULT_SCREEN_OPTIONS } from '../../../routing';

// ─────────────────────────────────────────────────────────────────────────────

export default function LoyaltyTabLayout() {
  return (
    <Stack screenOptions={DEFAULT_SCREEN_OPTIONS}>
      <Stack.Screen name="index" />
    </Stack>
  );
}
